import React from "react";
import {classNames} from "../tools/react.dom.helpers";


const GridItem = ({className, maxItemWidth, fitByContent, children}) =>
    <div className={classNames('grid-item', fitByContent && 'grid-item--fit-by-content', className)} style={{maxWidth: maxItemWidth}}>
        {children}
    </div>

export default GridItem;